module.exports = __webpack_public_path__ + "static/media/note-cascade-black.f4aa114e.png";